/* ==========================================================================
   ALAIN PHILIPPE · THE CORNER DIAL
   docs/gallery-standard.md §2. Markup: snippets/ap-dial.liquid.

   Two jobs, and deliberately only two:
     1. rotate the hand to the document's scroll progress
     2. keep the dial's tone equal to the tone of the section it is sitting on

   This is the only dial on the site since 9 September 2026. The collections
   walk had a second one that read ROOMS rather than the document; the walk is
   retired and that instrument went with it, so nothing here has to stand
   clear of a second dial any more.
   ========================================================================== */

(function () {
  'use strict';

  var dial = document.querySelector('[data-ap-dial]');
  if (!dial) return;

  var handGroup = dial.querySelector('.ap-dial__hand-g');
  var ticks = dial.querySelectorAll('.ap-dial__tick');
  var root = document.documentElement;

  /* THE TICKS ARE SPACED HERE, not in the markup, so the count can come from
     the store. 360/n, computed: adding a collection re-draws the face instead of
     needing a new angle typed into a stylesheet. */
  var i;
  var step = ticks.length ? 360 / ticks.length : 0;
  for (i = 0; i < ticks.length; i++) {
    ticks[i].style.transform = 'rotate(' + (step * i).toFixed(3) + 'deg)';
  }

  var frame = 0;
  var lastTone = '';
  var lastToneCheck = 0;

  /* THE RETONE IS TIME-GATED, and this is not a micro-optimisation.
     Reading it needs getBoundingClientRect plus elementFromPoint, which are two
     forced layouts. Doing that on every scroll frame of a long page is a real
     cost for a value that only changes when a section boundary passes the
     corner, which is a handful of times per page. The hand still moves every
     frame; only the tone question is asked at most every 180ms. */
  var TONE_MS = 180;

  function readTone(now) {
    if (now - lastToneCheck < TONE_MS) return;
    lastToneCheck = now;

    var box = dial.getBoundingClientRect();
    /* safe because the dial is pointer-events: none — it cannot find itself */
    var el = document.elementFromPoint(
      Math.round(box.left + box.width / 2),
      Math.round(box.top + box.height / 2)
    );

    var tone = '';
    while (el && el !== root) {
      if (el.getAttribute) {
        var t = el.getAttribute('data-tone');
        if (t) { tone = t; break; }
      }
      el = el.parentElement;
    }

    /* fall back to the document's own tone rather than guessing 'dark': the
       document is stamped server-side from the real ground, so it is right even
       after a regrade */
    if (!tone) tone = root.getAttribute('data-tone') || 'dark';

    if (tone !== lastTone) {
      dial.setAttribute('data-tone', tone);
      lastTone = tone;
    }
  }

  function paint(now) {
    frame = 0;

    var span = root.scrollHeight - window.innerHeight;
    var progress = 0;
    if (span > 0) {
      progress = window.pageYOffset / span;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;
    }

    if (handGroup) {
      handGroup.style.transform = 'rotate(' + (progress * 360).toFixed(2) + 'deg)';
    }

    readTone(typeof now === 'number' ? now : 0);
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(paint);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });

  /* revealed only once it is actually driving something */
  dial.classList.add('is-ready');

  /* first paint has to force the tone read, or the dial spends its first 180ms
     on the document tone while sitting on a light arrival */
  lastToneCheck = -TONE_MS;
  paint(0);
})();
